module.exports = 1;
module.exports = require("./circular");


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-amd/circular.js
 ** module id = 3
 ** module chunks = 0
 **/